import React from 'react';

const plans = [
   {
      name: 'Little Maker',
      target: "collégiens et lycéens",
      age: "10-17 ans",
      description: 'Découvrir & expérimenter',
      features: [
         "Flexible : Programme hybride adapté au calendrier scolaire",
         "Auto-apprentissage guidé + kits projets",
         "Tutorat 1:1",
         "Apprentissage pratique : Stages + résidence créative",
         "Certification pour booster son dossier académique."
      ],
      button: 'Découvrir le parcours Little Maker',
      link: '/little-maker'
   },
   {
      name: 'Bootcamps',
      target: "étudiants et débutants motivés",
      age: "18+",
      description: 'Se former & construire',
      features: [
         "Parcours intensif hybride (présentiel + en ligne).",
         "Tronc commun + spécialisation (design, fabrication numérique, électronique, IoT…).",
         "Apprentissage par projets.",
         "Tutorat international & peer-to-peer learning.",
         "Projet final → Certification & ouverture sur des opportunités."
      ],
      button: 'Explorer les Bootcamps',
      link: '/bootcamp'
   },
   {
      name: 'Tutorat',
      target: "prépa certifications & mentorat avancé",
      age: "18+",
      description: 'S’élever & certifier ses compétences',
      features: [
         "Coaching personnalisé avec des tuteurs internationaux.",
         "Préparation aux certifications makers reconnues (FabAcademy, MITx, etc.).",
         "Parcours flexible et adapté aux objectifs pros ou académiques."
      ],
      button: 'Trouver mon tuteur',
      link: '/tutorat'
   }
];

const PricingSection = () => {
   return (
      <section className="py-12 px-7 md:px-0 md:py-16 lg:py-24 bg-light-5 dark:bg-dark-2">
         <div className='w-full flex justify-center'>
            <div className="w-[80vw] px-4 lg:px-0  max-w-7xl md:max-w-7xl xl:max-w-[1700px]">
               <div className="text-center mb-10">
                  <h2 className="text-2xl sm:text-3xl md:text-title font-bold text-dark-1 dark:text-white mb-3 md:mb-4">
                     Choisis ton parcours !
                  </h2>
                  <p className="text-subtitle sm:text-base text-gray-600 dark:text-gray-300">
                     Des formules flexibles et adaptées à tous les âges et niveaux pour devenir un Maker.
                  </p>
               </div>

               <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-12 xl:gap-20">
                  {plans.map((plan, index) => (
                     <div
                        key={index}
                        className={`flex flex-col rounded-xl shadow-lg hover:shadow-xl dark:hover:shadow-purple-300/20 transition-shadow 
      ${index === 1 ? 'bg-purple-1 text-white' : 'bg-white dark:bg-dark-5 text-dark-1 dark:text-white'} w-full h-full`}
                     >
                        {/* Header */}
                        <div className={`mb-6 text-white text-start p-6 md:p-8 lg:p-10
         ${index === 1 ? 'bg-purple-1' : 'bg-dark-1 dark:bg-dark-6'} rounded-t-xl`}>
                           <h3 className="text-subtitle font-semibold mb-1">{plan.target}</h3>
                           <div className="flex items-baseline">
                              {plan.name && <span className="text-4xl md:text-title font-semibold">{plan.name}</span>}
                           </div>
                           <p className="text-subtitle mt-1">{plan.age}</p>
                        </div>

                        {/* Contenu + Bouton */}
                        <div className="flex flex-col flex-grow p-6 md:p-8">
                           <span className={`text-subtitle font-medium mb-4 block ${index === 1 ? 'text-white' : 'text-gray-600 dark:text-gray-300'}`}>
                              {plan.description}
                           </span>

                           <ul className="space-y-3 mb-6 flex-grow">
                              {plan.features.map((feature, i) => (
                                 <li key={i} className={`text-normal flex items-start ${index === 1 ? 'text-white' : 'text-gray-700 dark:text-gray-300'}`}>
                                    <svg
                                       className={`h-4 w-4 mt-0.5 mr-2 flex-shrink-0 ${index === 1 ? 'text-white' : 'text-purple-1 dark:text-purple-300'}`}
                                       fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                    </svg>
                                    {feature}
                                 </li>
                              ))}
                           </ul>

                           {/* Bouton toujours en bas */}
                           <a href={plan.link}>
                              <button className={`mt-auto w-full border py-4 px-3 rounded-md text-button font-medium transition-colors
         ${index === 1 ? 'bg-white text-purple-1 hover:bg-transparent hover:text-white hover:border-white' :
                                    'bg-transparent text-purple-1 hover:bg-purple-1 hover:text-white'}`}>
                                 {plan.button}
                              </button>
                           </a>
                        </div>
                     </div>

                  ))}
               </div>
            </div>
         </div>
      </section>
   );
};

export default PricingSection;